import { reducer as storeReducer } from 'store/common';
import ActionType from './actionType';
import i18n from 'i18n';

const initialState = {
  isReadOnlyMode: false,
  language: 'US',
};

const setReadOnlyMode = (state, payload) => {
  const ret = {
    ...state,
    ...{ isReadOnlyMode: payload.isReadOnlyMode },
  };
  return ret;
};

const setExternalAccessMode = (state, payload) => {
  const ret = {
    ...state,
    ...{ isExternalAccessMode: payload.isExternalAccessMode },
  };
  return ret;
};

const setLanguage = (state, payload) => {
  const { language } = payload;
  i18n.changeLanguage(language);
  return {
    ...state,
    ...{ language: language },
  };
};

const actionsMapping = {
  [ActionType.SET_READ_ONLY_MODE]: setReadOnlyMode,
  [ActionType.SET_EXTERNAL_ACCESS_MODE]: setExternalAccessMode,
  [ActionType.SET_LANGUAGE]: setLanguage,
};

const reducer = (state = initialState, action) => storeReducer(actionsMapping, state, action);

export default reducer;
